import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'Index',
      components: {
        default: () => import('@/views/Index'),
        Header: () => import('@/components/Header'),
        Bottom: () => import('@/components/Bottom')
      },
    },
  ],
  // scrollBehavior (to, from, savedPosition) {
  //   // return 期望滚动到哪个的位置
  //   return { x: 0, y: 0 }
  //   }
})
